import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { addGeneralParams } from "@shared/shared.slice";

/**
 * Custom hook to fetch general parameters only once globally
 */

export const useGeneralParams = () => {
  const dispatch = useDispatch();
  const generalParams = useSelector((state) => state.general.generalParameters);

  const fetchGeneralParams = () => {
    // Only fetch if not already loaded
    axios
      .get("/general/parameter")
      .then((response) => {
        dispatch(addGeneralParams(response.data));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (Object.keys(generalParams).length === 0) {
      fetchGeneralParams();
    }
  }, [generalParams]);

  return { fetchGeneralParams, generalParams };
};

export const useGetGeneralParameters = () => {
  return useSelector((state) => state.general.generalParameters);
};

export const useGetMainCurrencyByCountryId = (countryId) => {
  const generalParameters = useGetGeneralParameters();
  const value = generalParameters?.mainCurrencyList?.[countryId];
  return value !== undefined && value !== null ? parseInt(value, 10) : null;
};

export const useGetMultiUserCurrenciesByCountryId = (countryId) => {
  const generalParameters = useGetGeneralParameters();
  const userCurrencyObj = generalParameters?.userCurrencyList?.[countryId];
  if (!Array.isArray(userCurrencyObj)) return null;
  return userCurrencyObj.reduce(
    (prev, current) => ({ ...prev, [current.id]: current.label }),
    {}
  );
};

export const countryInfoById = (countryId) => {
  const generalParameters = useGetGeneralParameters();
  const countryData = generalParameters?.countryList.find(
    (info) => info.id === countryId
  );
  return countryData || null;
};

export const countryCordinatesById = (countryId) => {
  const generalParameters = useGetGeneralParameters();
  const countryData = generalParameters?.countryList.find(
    (info) => info.id === countryId
  );
  return { latitude: countryData.latitude, longitude: countryData.longitude };
};
